export enum PolicyStates {
  Wait4Sign = "Wait4Sign",
  Signed = "Signed",
  Na = "Na",
  Ongoing = "Ongoing",
  Temporary = "Temporary",
  Unpaid = "Unpaid",
  Suspended = "Suspended",
  Terminated = "Terminated",
  Replaced = "Replaced",
  Cancelled = "Cancelled",
}
